import { addToast } from '@octano/global-ui';
import { useCallback, useEffect, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

import { getCreditsByPeriod } from '../../../api/requests/periods';
import { useCourseSelectionState } from '../../../hooks/useCourseSelectionState';
import TuitionNotFoundModal, {
  TuitionErrors,
  TuitionNotFoundModalRef,
} from './TuitionNotFoundModal';

const prefix = 'courseRegistration';

const PeriodMinAndMaxCreditsCard = ({
  setEmailHelp,
}: {
  setEmailHelp: (email: string) => void;
}) => {
  const { t } = useTranslation();
  const { studyPlanEnrollmentId } = useParams<{
    studyPlanEnrollmentId: string;
  }>();
  const { creditsPeriod, setCreditsPeriod } = useCourseSelectionState();
  const tuitionNotFountModalRef = useRef<TuitionNotFoundModalRef>(null);

  const getPeriodCredits = useCallback(async () => {
    const { data, error } = await getCreditsByPeriod(studyPlanEnrollmentId);
    if (data) {
      setEmailHelp(data.helpEmail);
      setCreditsPeriod({
        creditMax: data.creditMax,
        creditMin: data.creditMin,
        creditConfigurationEnabled: data.creditConfigurationEnabled,
        creditsContracted: data.creditsContracted,
      });
    }
    if (error) {
      if (error.data.tuition === TuitionErrors.CURRENT_TUITION_NOT_FOUND) {
        tuitionNotFountModalRef.current?.openModal();
        return;
      }
      addToast({
        color: 'danger',
        icon: 'error',
        text: t('common.displayError.errorUnexpected'),
      });
    }
  }, [studyPlanEnrollmentId, setEmailHelp, setCreditsPeriod, t]);

  useEffect(() => {
    getPeriodCredits();
  }, [getPeriodCredits]);

  return (
    <div className="align-items-center justify-content-center py-2">
      <div className="outlined-box-primary">
        <Row className="fs-16">
          <Col xs={12} lg={4} className="d-flex justify-content-between">
            <span className="text-dark">
              <Trans t={t}>{t(`${prefix}.min`)}</Trans>
            </span>
            <span>{creditsPeriod.creditMin}</span>
          </Col>
          <Col xs={12} lg={4} className="d-flex justify-content-between">
            <span className="text-dark">
              <Trans t={t}>{t(`${prefix}.max`)}</Trans>
            </span>
            <span>{creditsPeriod.creditMax}</span>
          </Col>
        </Row>
      </div>
      <TuitionNotFoundModal ref={tuitionNotFountModalRef} />
    </div>
  );
};

export default PeriodMinAndMaxCreditsCard;
